<div class="formula-builder">
  <h3>Formula Builder</h3>
  @if (!builder_ready) {
    <div class="row center">Loading constant properties...</div>
  }
  @if (builder_ready) {
    <div class="row center selection-row">
      <!--parent component constant properties (currently could be 'Event Type' or 'Component Type'-->
      <div class="row center">
        <div class="select-search">
          <select-search
            (selectChange)="formula_constant_property"
            [(value)]="formula_constant_property"
            [classes]="'fill'"
            [data]="constant_properties_list"
            [label]="parent_component.attributes.name + ' (' + [parent_component.type | removeUnderscore] + ') Properties'"
            >
          </select-search>
        </div>
        <button (click)="addToFormula(formula_constant_property)"
          class="btn-addtotext form-element-align" title="Add to formula">
        </button>
      </div>
      <!--Component Type constant properties-->
      @if (parent_component.type !== 'component_type') {
        <div class="row center">
          <div class="select-search">
            <select-search
              (selectChange)="ct_formula_constant_property"
              [(value)]="ct_formula_constant_property"
              [classes]="'fill'"
              [data]="ct_constant_properties_list"
              [label]="'Component Type Properties'"
              [stringFunction]="typePropertyString"
              >
            </select-search>
          </div>
          <button (click)="addToFormula(ct_formula_constant_property, 'component')"
            class="btn-addtotext form-element-align" title="Add to formula">
          </button>
        </div>
      }
      <!--Event Type constant properties-->
      @if (parent_component.type !== 'event_type') {
        <div class="row center" >
          <div class="select-search">
            <select-search
              (selectChange)="et_formula_constant_property"
              [(value)]="et_formula_constant_property"
              [classes]="'fill'"
              [data]="et_constant_properties_list"
              [label]="'Event Type Properties'"
              [stringFunction]="typePropertyString"
              >
            </select-search>
          </div>
          <button (click)="addToFormula(et_formula_constant_property, 'component@component_type')"
            class="btn-addtotext form-element-align" title="Add to formula">
          </button>
        </div>
      }
      <!--Component Type "constants" constant properties-->
      @if (parent_component.type === 'component_type') {
        <div class="row center" >
          <div class="select-search" >
            <select-search
              (selectChange)="constant_formula_constant_property"
              [(value)]="constant_formula_constant_property"
              [classes]="'fill'"
              [data]="ct_constants_list"
              [label]="'Component Type Constants'"
              [stringFunction]="typePropertyString"
              >
            </select-search>
          </div>
          <button (click)="addToFormula(constant_formula_constant_property, 'component_type')"
            class="btn-addtotext form-element-align" title="Add to formula">
          </button>
        </div>
      }
    </div>
  }

  <div class="row text-row">
    <textarea [(ngModel)]="constant_property.attributes.name_formula" name="name_formula"
      rows="3">
    </textarea>
  </div>
  <!--   <div class="row action-buttons">-->
  <!--     <button class="save" (click)="submitFormula()">Submit</button>-->
<!--   </div>-->
</div>
